import {
  MedScreenName,
  trackCareTabViewed,
} from "../../nativeAnalytics/medAnalytics";
import { useTrackOnceWithRetry } from "../../nativeAnalytics/hooks/useTrackOnceWithRetry";

const logPrefix = "[CareTabAnalytics]";

/**
 * Fires `care_tab_viewed` when the component that calls this hook
 * mounts. Caller contract: call from a LEAF component that only mounts
 * once treatments are ready to render (i.e. inside the success branch
 * of the loading / error ternary). Do NOT pass loading / error flags;
 * if the data isn't ready, don't render the component that calls this
 * hook. The hook signature stays generic as new queries / data sources
 * are added at the CareTabPage level.
 *
 * Same-mount dedup is handled by the shared `useTrackOnceWithRetry`'s
 * `hasSentRef`, so rerenders do not duplicate the event. A fresh mount
 * should emit a fresh page-view event.
 */
export function useTrackCareTabViewed() {
  useTrackOnceWithRetry({
    enabled: true,
    dispatch: trackCareTabViewed,
    logPrefix,
    logContext: { screenName: MedScreenName.CareTab },
  });
}
